import { AxiosResponse } from 'axios'
import SecureClient from '../SecureClient'
import { BaseEventListenerModel, EventListener, EventListenerMetadata } from './DTO'

export default class EventListenersClient extends SecureClient {
	/**
	 * get all event listeners for an organization
	 * @returns 
	 */
	public getEventListeners = (): Promise<AxiosResponse<EventListener[]>> => {
		return this._api.get<EventListener[]>(
			`EventListeners`,
			{
				headers: {
					...this.authorizationHeader,
					...this.acceptHeader(),
					...this.contentTypeHeader(),
				},
			},
		)
	}

	/**
	 * get one event listener
	 * @param eventListenerId 
	 * @returns 
	 */
	public getEventListener = (eventListenerId: number): Promise<AxiosResponse<EventListener>> => {
		return this._api.get<EventListener>(
			`EventListeners/${eventListenerId}`,
			{
				headers: {
					...this.authorizationHeader,
					...this.acceptHeader(),
					...this.contentTypeHeader(),
				},
			},
		)
	}

	/**
	 * get the metadata for all event listeners - display name,
	 * description, event id, event handler type, and id
	 * @returns 
	 */
	public getEventListenerMetadata = (): Promise<AxiosResponse<EventListenerMetadata[]>> => {
		return this._api.get<EventListenerMetadata[]>(
			`EventListeners/Metadata`,
			{
				headers: {
					...this.authorizationHeader,
					...this.acceptHeader(),
					...this.contentTypeHeader(),
				}
			},
		)
	}

	/**
	 * create an event listener
	 * @param model the name, description, event id, event handler type, 
	 * and state for the event listener to create
	 * @returns the created event listener
	 */
	public createEventListener = (
		model: BaseEventListenerModel,
	): Promise<AxiosResponse<EventListener>> => {
		return this._api.post<EventListener>(
			`EventListeners`,
			model,
			{
				headers: {
					...this.authorizationHeader,
					...this.acceptHeader(),
					...this.contentTypeHeader(),
				},
			},
		)
	}

	/**
	 * update an existing event listener
	 * @param instanceId the id of the listener to update
	 * @param model the updated configuration for the listener
	 * @returns the updated event listener
	 */
	public updateEventListener = (
		eventListenerId: number,
		model: BaseEventListenerModel,
	): Promise<AxiosResponse<EventListener>> => {
		return this._api.put<EventListener>(
			`EventListeners/${eventListenerId}`,
			model,
			{
				headers: {
					...this.authorizationHeader,
					...this.acceptHeader(),
					...this.contentTypeHeader(),
				},
			},
		)
	}

	/**
	 * delete an event listener
	 * @returns 
	 */
	public deleteEventListener = (
		eventListenerId: number,
	): Promise<AxiosResponse> => {
		return this._api.delete(
			`EventListeners/${eventListenerId}`,
			{
				headers: {
					...this.authorizationHeader,
					...this.acceptHeader(),
					...this.contentTypeHeader(),
				},
			},
		)
	}
}
